import { css } from 'styled-components'

export const baseLine = css`
  line-height: 1.2;
  font-weight: 600;
  padding-bottom: ${(props) => props.theme.spacing.md};
  padding-top: 0;
  margin-bottom: 0;
  margin-top: 0;
  text-align: left;
  color: ${(props) => props.theme.colors.greyDark};
`

type HeadingSizes = 'sm' | 'md' | 'lg' | 'xl'
export interface HeadingProps {
  size?: HeadingSizes
}
export const getHeadingSize = (props) => css`
  font-size: ${props.theme.font.heading.size[props.size]};
`

export const HeadingStyles = css`
  ${baseLine};
  ${getHeadingSize};
`
